import * as React from 'react';
import { Link as ReactRouterLink, LinkProps } from 'react-router-dom';

/** Bridges react-router-dom v4 Link with @types/react 16.14 JSX checks. */
export const Link = ReactRouterLink as unknown as React.ComponentType<LinkProps>;

export type { LinkProps };



// WEBPACK FOOTER //
// ./src/components/RouterLink.tsx